enum AuthRoutes {
  Login = '/auth/login',
  NotPermitted = 'not-permitted',
}

export default AuthRoutes
